import React from "react"
import PodcastIcon from "images/podcast-icon.svg"
import {
  Card,
  Header,
  IconWrapper,
  ImageWrapper,
  Logo,
  Image,
  ImageContent,
  ImageOverlay,
  Content,
  Headline,
  AuthorName,
  AuthorRole,
} from "./styles"

const PodcastSquareCard = ({ refImage, props }) => (
  <Card>
    <a href={props?.link}>
      <Header>
        <Logo>
          the <br /> mindbodygreen
          <br /> podcast
        </Logo>
        <IconWrapper>
          <img src={PodcastIcon} alt="podcast-icon" />
        </IconWrapper>
      </Header>
      <ImageWrapper>
        <ImageContent>
          <ImageOverlay />
          <Image
            elRef={refImage}
            variant="4col"
            baseUrl={props.image && props.image[0] && props.image[0]?.secure_url}
            alt={props.headline}
            images={[
              {
                screenSize: 0,
                transforms: `c_fit,w_149,h_143,q_90,fl_lossy,f_auto`,
              },
            ]}
            lazy
            isGrid
          />
        </ImageContent>
      </ImageWrapper>
      <Content>
        <Headline>{props.headline}</Headline>
        <AuthorName>{props.byline}</AuthorName>
        <AuthorRole>{props.reviewByline}</AuthorRole>
      </Content>
    </a>
  </Card>
)

export default PodcastSquareCard
